module.exports = __webpack_public_path__ + "img/bag_2.492c0b14.svg";